module.exports = __webpack_public_path__ + "static/media/pricing4.25e1f12a.jpg";